export class PageEnum {
  // basic login path
  static BASE_LOGIN = '/offline';
  static BASE_OFFLINE = '/offline';
  // basic home path
  static BASE_HOME = '/goodsManage';
  // basic home path
  static ONLINE_HOME = '/account';
  static OFFLINE_HOME = '/goodsManage';
  // error page path
  static ERROR_PAGE = '/exception';
  // error log page path
  static ERROR_LOG_PAGE = '/error-log/list';
}
export const PageWrapperFixedHeightKey = 'PageWrapperFixedHeight';
